<template>
  <div>
    <v-card class="pa-5">
      <v-card-title>
        <v-spacer/>
        <v-text-field
          style="max-width: 250px"
          dense
          outlined
          clearable
          :placeholder="$t('general.search')"
          v-model="search"
          append-icon="search"
          hide-details
          class="mr-2"
          @keyup.enter="searching"
          @click:append="searching"
        />
        <v-btn
          depressed
          color="primary"
          to="/company/add">
          {{$t('company.add')}}
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-overlay
          absolute
          opacity="0"
          :value="loadingTable"
        >
        </v-overlay>
        <v-data-table
          :loading="loadingTable"
          :loading-text="$t('general.loading')"
          :headers="headers"
          :items="companies"
          :search="search"
          :server-items-length="options.totalItems"
          :options.sync="options"
          :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
          @update:page="get"
          @update:items-per-page="get"
          @update:sort-by="get"
          @update:sort-desc="get"
        >
        <template v-slot:item="props" >
          <tr>
            <td>{{props.item.id}}</td>
            <td>{{props.item.name}}</td>
            <td>{{props.item.phone}}</td>
            <td>{{props.item.address.city}}</td>
            <td>{{props.item.address.state}}</td>
            <td>{{props.item.address.country.name}}</td>
            <td>{{props.item.address.zip_code}}</td>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    class="mr-2"
                    @click="editItem(props.item)"
                  >
                    far fa-edit
                  </v-icon>
                </template>
                <span>{{$t('general.edit')}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    class="mr-2"
                    @click="showDelete(props.item)"
                  >
                    far fa-trash-alt
                  </v-icon>
                </template>
                <span>{{$t('general.remove')}}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="error--text grey lighten-5"
        >
          {{$t('company.delete')}}
        </v-card-title>

        <v-card-text class="pt-5">
          <span>{{$t('company.delMessage')}}</span> <span class="font-weight-bold">{{company.name}}</span> ?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="deleteDialog = false"
          >
           {{$t('general.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            @click="deleteCompany"
          >
           {{$t('general.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      deleteDialog: false,
      loadingTable: true,
      file: {},
      companies: [],
      company: {
        id: 0,
        name: '',
        phone: '',
        city: '',
        state: '',
        country: '',
        zip: ''
      },
      options: {
        descending: true,
        page: 1,
        orderBy: 'id',
        itemsPerPage: 15,
        totalItems: 8
      }
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Id',
          align: 'center',
          value: 'id'
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('general.phone'),
          align: 'center',
          value: 'phone'
        },
        {
          text: this.$t('address.city'),
          align: 'center',
          value: 'address.city'
        },
        {
          text: this.$t('address.state'),
          align: 'center',
          value: 'address.state'
        },
        {
          text: this.$t('address.country'),
          align: 'center',
          value: 'address.country.name'
        },
        {
          text: this.$t('address.zip'),
          align: 'center',
          value: 'address.zip_code'
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.get()
  },
  watch: {
    search (val) {
      if (val === '' || val === null) {
        this.searching()
      }
    }
  },
  methods: {
    get () {
      this.loadingTable = true
      this.$store.dispatch('company/get', {
        event: {
          context: this,
          item: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy ? this.options.sortBy[0] : undefined,
            ord: this.options.sortDesc && this.options.sortDesc[0] ? 'desc' : 'asc',
            find: this.search
          }
        }
      })
    },
    searching () {
      this.options.page = 1,
      this.options.perPage = 5
      this.get()
    },
    editItem (item) {
      this.$router.push('/company/edit/' + item.id)
    },
    showDelete (item) {
      this.company = item
      this.deleteDialog = true
    },
    deleteCompany () {
      this.$store.dispatch('company/delete', {
        event: {
          context: this,
          id: this.company.id
        }
      })
      this.deleteDialog = false
    }
  }
}
</script>
